import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DatePicker } from 'antd';
import moment from 'moment';
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

interface GeneralInfoProps {
  editMode: boolean;
  examData: any;
  study: any;
  handleDOBChange: any;
  setExamData: any;
  handleAgeChange: any;
  handleLMPChange: any;
  handleGAChange: any;
  handleExamChange: any;
  handleMSChange: any;
  handleRHPChange: any;
  setLMP: any;
  LMP: any;
  formattedDate: any;
  calculateGestationalAge: any;
}

const GeneralInfo: React.FC<GeneralInfoProps> = ({
  editMode,
  examData,
  study,
  setLMP,
  LMP,
  calculateGestationalAge,
  formattedDate,
  handleDOBChange,
  setExamData,
  handleAgeChange,
  handleLMPChange,
  handleGAChange,
  handleExamChange,
  handleMSChange,
  handleRHPChange,
}) => {
  console.log('study++**', study);

  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }

  function calculateAge(dateString) {
    const birthDate = new Date(dateString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  }

  const [GA, setGA] = useState({
    gestationalAgeWeeks: 0,
    gestationalAgeDays: 0,
  });
  const [TGA, setTGA] = useState({
    gestationalAgeWeeks: 0,
    gestationalAgeDays: 0,
  });

  useEffect(() => {
    const ga = calculateGestationalAge(LMP);
    setGA(JSON.parse(ga));
  }, [LMP]);
  useEffect(() => {
    const ga = calculateGestationalAge(study?.last_menstrual_period);
    setTGA(JSON.parse(ga));
  }, [study]);
  console.log('deepseek', dayjs(study?.last_menstrual_period), study);
  return (
    <div className="w-full mb-4">
      <div className="mb-2 w-full rounded-md p-1.5 font-medium bg-card-color-200 text-title-page-color-100 text-sm">
        General Information
      </div>
      <div className="grid grid-cols-2 gap-x-2 gap-y-1 px-1 text-xs md:text-sm text-title-page-color-100">
        {/* DOB Field */}
        <div>
          <label className="block">DOB</label>
          <div className="mt-0.5 w-full rounded-lg border p-1.5">
            {formatDate(study?.birth_date)}
          </div>
        </div>

        {/* Age Field */}
        <div>
          <label className="block">Age</label>
          <div className="mt-0.5 w-full rounded-lg border p-1.5">
            {calculateAge(formatDate(study?.birth_date))}
          </div>
        </div>

        {/* LMP Field */}
        <div>
          <label className="block text-[#686C82]">LMP</label>
          {editMode ? (
            <div className="mt-0.5 w-full">
              <DatePicker
                size="small"
                className="w-full rounded-lg border p-1.5 focus:ring focus:ring-blue-200"
                disabled={!editMode}
                // defaultValue={
                //   LMP &&
                //   dayjs(LMP)
                // }
                value={LMP ? dayjs(LMP) : null}

                // disabledDate={(current) => current && current > moment().endOf('day')}
                maxDate={dayjs()}
                minDate={dayjs().subtract(42, 'week')}
                onChange={(date, dateString) => {
                  setLMP(dateString?.length > 0 ? dateString : null);
                }}
              />
            </div>
          ) : (
            <div className="mt-0.5 w-full rounded-lg border p-1.5">
              {study?.last_menstrual_period
                ? formatDate(study?.last_menstrual_period)
                : '***'}
            </div>
          )}
        </div>

        {/* GA from LMP Field */}
        <div>
          <label className="block text-[#686C82]">
            {editMode ? 'GA from LMP' : 'Gestational Age'}
          </label>
          <div className="mt-0.5 w-full rounded-lg border p-1.5 cursor-not-allowed">
            {GA?.gestationalAgeWeeks !== undefined &&
            GA?.gestationalAgeDays !== undefined
              ? `${GA.gestationalAgeWeeks}w ${GA.gestationalAgeDays}d`
              : '***'}
          </div>
        </div>

        {/* Medical Status Field */}
        <div>
          <label className="block text-[#686C82]">Medical Status</label>
          <div className="mt-0.5 w-full rounded-lg border p-1.5">***</div>
        </div>

        {/* Reference hospital or Practitioner Field */}
        <div>
          <label className="block text-[#686C82]">
            Ref. Hospital/Practitioner
          </label>
          <div className="mt-0.5 w-full rounded-lg border p-1.5">***</div>
        </div>

        {/* Exam Field */}
        <div className="col-span-2 md:col-span-1">
          <label className="block text-[#686C82]">Exam</label>
          <div className="mt-0.5 w-full rounded-lg border p-1.5">
            OB-GYN 3rd Trimester
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralInfo;
